'use strict';

import {DOM} from '../helpers/DOM.js';

export default class Slider {
	constructor() {
		if (DOM.el('.levcharity_slider')) {
			this.#addEvents();
			this.update();
		}
	}

	#addEvents() {
		DOM.addEvent('LevCharityUpdateSlider', (e) => {
			this.update();
		})
	}

	async update() {
		const {Swiper} = await import('swiper/bundle');

		document.querySelectorAll('.levcharity_slider')
			.forEach(swiperElement => {
				const slidesPerView = +swiperElement?.dataset?.slidesToShow || 1;
				const slidesPerGroup = +swiperElement?.dataset?.slidesPerGroup || 1;
				const loop = (swiperElement?.dataset?.infinite || 'true') === 'true';
				const centeredSlides = (swiperElement?.dataset?.center || 'false') === 'true';
				const autoplay = (swiperElement?.dataset?.autoplay || 'false') === 'true';
				const autoplayDelay = +(swiperElement?.dataset?.autoplayDelay ?? 3000);

				const breakpoint_sizes = (swiperElement?.dataset?.breakpoints || '').split(',').filter(bp => bp);

				const breakpoints = {};

				breakpoint_sizes.forEach(bp => {
					const slidesToShowAttr = swiperElement.getAttribute(`data-${bp}-slides-to-show`);
					const slidesPerGroupAttr = swiperElement.getAttribute(`data-${bp}-slides-per-group`);
					const centerAttr = swiperElement.getAttribute(`data-${bp}-center`);

					const slidesPerView = slidesToShowAttr ? +slidesToShowAttr : 1;
					const slidesPerGroup = slidesPerGroupAttr ? +slidesPerGroupAttr : 1;
					const centeredSlides = centerAttr === 'true';

					breakpoints[+bp] = {
						slidesPerView,
						slidesPerGroup,
						centeredSlides,
						spaceBetween: +bp < 768 ? 10 : 20
					};
				});

				const totalSlides = swiperElement.querySelectorAll('.levcharity_slider_slide').length;
				const shouldLoop = loop && totalSlides > slidesPerView;

				const config = {
					direction: 'horizontal',
					loop: shouldLoop,
					centeredSlides,
					centeredSlidesBounds: centeredSlides,
					autoHeight: false,
					allowTouchMove: true,
					touchEventsTarget: 'container',
					watchOverflow: true,
					width: null,
					pagination: {
						el: swiperElement.querySelector('.levcharity_slider_dots'),
						clickable: true,
					},
					navigation: {
						nextEl: swiperElement.querySelector('.levcharity_slider_next_button'),
						prevEl: swiperElement.querySelector('.levcharity_slider_prev_button'),
					},
					effect: 'slide',
					spaceBetween: 20,
					slidesPerView,
					slidesPerGroup,
					breakpoints,
					on: {
						init: function() {
							const slides = this.slides;
							slides.forEach(slide => {
								slide.style.maxWidth = '100%';
								slide.style.width = 'auto';
							});
						},
						resize: function() {
							const slides = this.slides;
							slides.forEach(slide => {
								slide.style.maxWidth = '100%';
								slide.style.width = 'auto';
							});
						}
					}
				};

				if (autoplay) {
					config.autoplay = {
						delay: autoplayDelay,
						disableOnInteraction: false,
					};
				}

				new Swiper(swiperElement, config);
			})


	}
}
